import { Drawer, Hidden, SwipeableDrawer } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import React from 'react';

export const drawerWidth = 256;

const useStyles = makeStyles((theme: Theme) => ({
  drawer: {
    [theme.breakpoints.up('lg')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  paper: {
    width: drawerWidth,
    backgroundColor: theme.palette.background.paper,
  },
}));

interface AppDrawerProps {
  open: boolean;
  onOpen: React.ReactEventHandler<unknown>;
  onClose: React.ReactEventHandler<unknown>;
  disablePermanent?: boolean;
  children: React.ReactNode;
}

export default function AppDrawer({
  open,
  onOpen,
  onClose,
  disablePermanent = false,
  children,
}: AppDrawerProps): JSX.Element {
  const classes = useStyles();

  return (
    <nav className={classes.drawer} aria-label="mainNavigation">
      <Hidden lgUp={!disablePermanent} implementation="js">
        <SwipeableDrawer
          classes={{
            paper: classes.paper,
          }}
          variant="temporary"
          open={open}
          onOpen={onOpen}
          onClose={onClose}
          ModalProps={{
            keepMounted: true,
          }}
        >
          {children}
        </SwipeableDrawer>
      </Hidden>
      {disablePermanent ? null : (
        <Hidden mdDown implementation="css">
          <Drawer
            classes={{
              paper: classes.paper,
            }}
            variant="permanent"
            open
          >
            {children}
          </Drawer>
        </Hidden>
      )}
    </nav>
  );
}
